module.exports = __webpack_public_path__ + "img/arrow.547bac49.svg";